import React from "react";
import { Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import { Info as InfoCircle } from "@material-ui/icons";
import alternateCountryTranslations from "infrastructure/translate/alternateCountyTranslations";
import authClient from "../../../../app/auth/Auth";
import { translate as t } from "../../../../infrastructure/translate/localization";
import { showIFeelFeature } from "../../../../infrastructure/chosen-company";
import { PaymentList } from "./PaymentList";

import { ConsumptionCategory } from "./ConsumptionCategory/ConsumptionCategory";

export const EmployeeDetailsConsumption = ({
  adjustments,
  pendings,
  autoCloseDay,
  lastPayrollCloseFormatted,
  country,
}) => {
  if (!adjustments) return null;

  const {
    mealsFromSalary,
    mealsFromFlexNotExempt,
    companyGivenBenefits,
    transportFromSalary,
    transportFromFlexNotExempt,
    companyGivenTransportBenefits,
    childcareFromSalary,
    companyGivenNurseryBenefits,
    educationFromSalary,
    educationFromFlexNotExempt,
    companyGivenEducationBenefits,
    healthInsuranceFromSalary,
    companyGivenHealthInsuranceBenefits,
    healthInsuranceFromFlexNotExempt,
    nurseryFromFlexNotExempt,
  } = adjustments;
  const infoText1 = t("monitoring-section.payroll-close-info-1b");
  const infoText2 = t("monitoring-section.payroll-close-info-2b");
  const infoText3 = t("monitoring-section.payroll-close-info-3");
  const showInfoClose = autoCloseDay && lastPayrollCloseFormatted;
  const companyId = authClient.getCompanyId();
  return (
    <Grid spacing={4} container>
      {showInfoClose && (
        <Grid alignItems="center" item spacing={2} container>
          <InfoCircle className="icon-sized icon-secondary" />
          <Grid item>
            {`${infoText1} ${lastPayrollCloseFormatted}${infoText2} ${autoCloseDay} ${infoText3}`}
            .
          </Grid>
        </Grid>
      )}

      <Grid container item spacing={4}>
        <Grid xs={4} item container>
          <ConsumptionCategory
            icon="utensils"
            title={t("benefits-section.meal-benefit.meal")}
            flex={mealsFromSalary}
            socialBenefit={companyGivenBenefits}
            flexNotExempt={mealsFromFlexNotExempt}
          />
        </Grid>
        <Grid xs={4} item container>
          <ConsumptionCategory
            icon="bus"
            title={t("benefits-section.transport-benefit.transport")}
            flex={transportFromSalary}
            socialBenefit={companyGivenTransportBenefits}
            flexNotExempt={transportFromFlexNotExempt}
          />
        </Grid>
        <Grid xs={4} item container>
          <ConsumptionCategory
            icon="baby-carriage"
            title={t("benefits-section.nursery-benefit.nursery")}
            flex={childcareFromSalary}
            socialBenefit={companyGivenNurseryBenefits}
            flexNotExempt={nurseryFromFlexNotExempt}
          />
        </Grid>
        <Grid xs={4} item container>
          <ConsumptionCategory
            icon="book-reader"
            title={t("benefits-section.education-benefit.education")}
            flex={educationFromSalary}
            socialBenefit={companyGivenEducationBenefits}
            flexNotExempt={educationFromFlexNotExempt}
          />
        </Grid>
        {showIFeelFeature(companyId) ? (
          <Grid xs={4} item container>
            <ConsumptionCategory
              icon="user-md"
              title={t("benefits-section.ifeel-benefit.ifeel")}
              flex={healthInsuranceFromSalary}
              socialBenefit={companyGivenHealthInsuranceBenefits}
              flexNotExempt={healthInsuranceFromFlexNotExempt}
            />
          </Grid>
        ) : (
          <Grid xs={4} item container>
            <ConsumptionCategory
              icon="user-md"
              title={alternateCountryTranslations(country, "health-insurance")}
              flex={healthInsuranceFromSalary}
              socialBenefit={companyGivenHealthInsuranceBenefits}
              flexNotExempt={healthInsuranceFromFlexNotExempt}
            />
          </Grid>
        )}
      </Grid>

      <PaymentList
        title={t("employees-section.pending-payments")}
        info={t("employees-section.sumary-consumptions-pending-info")}
        noDataInfo={t("employees-section.no-pending-payments")}
        payments={pendings}
      />
    </Grid>
  );
};

EmployeeDetailsConsumption.propTypes = {
  adjustments: PropTypes.object.isRequired,
  pendings: PropTypes.array,
  autoCloseDay: PropTypes.string,
  lastPayrollCloseFormatted: PropTypes.string,
  country: PropTypes.string,
};

EmployeeDetailsConsumption.defaultProps = {
  pendings: [],
  autoCloseDay: null,
  lastPayrollCloseFormatted: null,
  country: "ES",
};

export default EmployeeDetailsConsumption;
